import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function usePublicRestaurantCities() {
  return useQuery({
    queryKey: ["public-restaurant-cities"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("restaurants_public")
        .select("city")
        .eq("is_active", true);
      if (error) throw error;
      return Array.from(new Set((data ?? []).flatMap(r => r.city ? [r.city] : []))).sort();
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}